import { increasePageNumber } from './page-number';
import type { ReportProps, FullReportProps } from './types';

export const createReportProps = (props: ReportProps): FullReportProps => ({
  ...props,
  endpoint: 'headless',
});

export const PageView = (): ReportProps => {
  increasePageNumber();

  return createReportProps({
    src: 76,
    evid: 1109,
    params: {
      url: document.location.href,
      ref: document.referrer,
    },
  });
};
